import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "tw-flex tw-items-center tw-gap-4 tw-m-4 tw-flex-wrap tw-flex-col-reverse lg:tw-flex-row lg:tw-flex-nowrap tw-justify-center lg:tw-justify-between" };
const _hoisted_2 = { class: "tw-text-sm tw-px-7 !tw-text-muted !tw-text-[#738499]" };
const _hoisted_3 = { class: "tw-font-medium !tw-text-[#738499]" };
const _hoisted_4 = { class: "tw-font-medium !tw-text-[#738499]" };
const _hoisted_5 = { class: "tw-font-medium !tw-text-[#738499]" };
import { Pagination, PaginationLast, PaginationList, PaginationPrev, PaginationNext, PaginationFirst, PaginationEllipsis, PaginationListItem, } from "@/components/ui/pagination";
import { Button } from "@/components/ui/button";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TablePagination',
    props: /*@__PURE__*/ _mergeModels({
        total: {},
        lastIndex: {},
        firstIndex: {},
        itemsPerPage: { default: 10 }
    }, {
        "modelValue": { default: 1 },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const model = _useModel(__props, "modelValue");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Pagination), {
                    page: model.value,
                    "onUpdate:page": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                    "show-edges": "",
                    total: _ctx.total,
                    "items-per-page": _ctx.itemsPerPage
                }, {
                    default: _withCtx(({ page }) => [
                        _createVNode(_unref(PaginationList), { class: "tw-flex tw-items-center tw-gap-3 tw-flex-wrap" }, {
                            default: _withCtx(({ items }) => [
                                _createVNode(_unref(PaginationFirst), { class: "tw-border-none !tw-p-0 !tw-bg-transparent rtl:tw-rotate-180 tw-text-[#2499ef] tw-transition-all tw-duration-300 hover:!tw-bg-[#2499ef1a] tw-cursor-pointer" }),
                                _createVNode(_unref(PaginationPrev), { class: "tw-border-none !tw-p-0 !tw-bg-transparent rtl:tw-rotate-180 tw-text-[#2499ef] tw-transition-all tw-duration-300 hover:!tw-bg-[#2499ef1a] tw-cursor-pointer" }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        (item.type === 'page')
                                            ? (_openBlock(), _createBlock(_unref(PaginationListItem), {
                                                key: index,
                                                value: item.value,
                                                "as-child": ""
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(Button), {
                                                        class: "tw-w-8 tw-max-w-8 tw-h-8 tw-p-0 tw-border-none custom-button-theme-bg tw-transition-all tw-duration-300 tw-cursor-pointer",
                                                        variant: item.value === page ? 'default' : 'outline'
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(item.value), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["variant"])
                                                ]),
                                                _: 2
                                            }, 1032, ["value"]))
                                            : (_openBlock(), _createBlock(_unref(PaginationEllipsis), {
                                                key: item.type,
                                                index: index
                                            }, null, 8, ["index"]))
                                    ], 64));
                                }), 256)),
                                _createVNode(_unref(PaginationNext), { class: "tw-border-none !tw-p-0 !tw-bg-transparent rtl:tw-rotate-180 tw-text-[#2499ef] tw-transition-all tw-duration-300 hover:!tw-bg-[#2499ef1a] tw-cursor-pointer" }),
                                _createVNode(_unref(PaginationLast), { class: "tw-border-none !tw-p-0 !tw-bg-transparent rtl:tw-rotate-180 tw-text-[#2499ef] hover:!tw-bg-[#22303be6] tw-cursor-pointer" })
                            ]),
                            _: 2
                        }, 1024)
                    ]),
                    _: 1
                }, 8, ["page", "total", "items-per-page"]),
                _createElementVNode("p", _hoisted_2, [
                    _cache[1] || (_cache[1] = _createTextVNode(" Showing ")),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.firstIndex), 1),
                    _cache[2] || (_cache[2] = _createTextVNode(" to ")),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.lastIndex), 1),
                    _cache[3] || (_cache[3] = _createTextVNode(" of ")),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.total), 1),
                    _cache[4] || (_cache[4] = _createTextVNode(" entries "))
                ])
            ]));
        };
    }
});
